module.exports = __webpack_public_path__ + "img/15.b28fb279.jpg";